var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    stroke: "#929292",
    strokeWidth: 4,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1654 32H43.1654L37.832 40H27.1654L21.832 32H5.83203",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.032 13.6267L5.83203 32V48C5.83203 49.4145 6.39393 50.771 7.39413 51.7712C8.39432 52.7714 9.75088 53.3333 11.1654 53.3333H53.832C55.2465 53.3333 56.6031 52.7714 57.6033 51.7712C58.6035 50.771 59.1654 49.4145 59.1654 48V32L49.9654 13.6267C49.5238 12.7381 48.8432 11.9903 47.9999 11.4674C47.1567 10.9445 46.1843 10.6672 45.192 10.6667H19.8054C18.8131 10.6672 17.8407 10.9445 16.9975 11.4674C16.1542 11.9903 15.4736 12.7381 15.032 13.6267Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty-box.1d5e24f8843548e1a0e43c3f4da8e1d5.svg";
export { ForwardRef as ReactComponent };